import clsx from "clsx";
import Editor from "../../../../../Editor/Editor";
import dialogStyles from "../dialogStyles.module.css";
import React from "react";

interface Props {
  label: string;
  value: string;
  onEdit: any;
  name: string;
  editStyle?: number;
  readonly?: boolean;
  id?: number;
  list?: any;
  onList?: any;
  button?: React.JSX.Element;
  afterLabel?: string;
  short?: boolean;
  hidden?: boolean;
  disabled?: boolean;
}

/**
 * Элемент карточки для нумерации
 *
 * @param {Object} [props] объект с данными
 * @param {string} [props.label] заголовок
 * @param {string} [props.name] имя редактора
 * @param {string} [props.value] значение редактора
 * @param {string} [props.id] id значения
 * @param {string} [props.editStyle] тип редактирования
 * @param {string} [props.afterLabel] заголовок после редактора
 * @param {string} [props.disabled] состояние выключения редактора
 * @param {string} [props.hidden] скрытие элемента
 * @param {string} [props.readonly] состояние редактора: редактирование с помощью кнопок
 * @param {string} [props.button] кнопка после редактора
 * @param {string} [props.list] список для редактора
 * @param {Object} [props.onEdit] функция редактирования
 * @param {string} [props.onList] функция получения списка
 * @param {string} [props.short] короткий редактор
 *
 * @returns Возвращает элемент для карточки нумерации
 */
export default function DialogDocNumberingCardItem(props: Props) {
  const {
    label,
    name,
    onEdit,
    value,
    editStyle,
    afterLabel,
    disabled,
    hidden,
    readonly,
    button,
    id,
    list,
    onList,
    short,
  } = props;

  return (
    <div className={clsx(dialogStyles.dialogDocNumberingCardItem, hidden && dialogStyles.dialogHidden)}>
      <div className={clsx(dialogStyles.dialogDocNumberingEditorLabel)}>{label}</div>
      <div
        className={clsx(
          short ? dialogStyles.dialogDocNumberingShortEditorContainer : dialogStyles.dialogDocNumberingEditorContainer,
        )}
      >
        <Editor
          disabled={disabled}
          name={name}
          editStyle={editStyle}
          readonly={readonly}
          value={value}
          objref={id}
          list={list}
          onDropDownList={onList}
          onEdit={onEdit}
        />
      </div>
      {button}
      {afterLabel && (
        <div className={clsx(dialogStyles.dialogDocNumberingEditorLabel, dialogStyles.dialogPaddingLeft)}>
          {afterLabel}
        </div>
      )}
    </div>
  );
}
